/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';

export interface GetRedirectRequest {
  redirectPath: string;
  effectiveDate?: Date;
  locale?: GetRedirectLocaleEnum;
  pid?: string;
  siteId?: GetRedirectSiteIdEnum;
  status?: Array<string>;
  userId?: number;
  audienceIds?: Array<string>;
  xChewyInternal?: string;
}

/**
 *
 */
export class PreviewApi extends runtime.BaseAPI {
  /**
   * Preview the requested page
   */
  async getRedirectRaw(
    requestParameters: GetRedirectRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.redirectPath === null || requestParameters.redirectPath === undefined) {
      throw new runtime.RequiredError(
        'redirectPath',
        'Required parameter requestParameters.redirectPath was null or undefined when calling getRedirect.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.redirectPath !== undefined) {
      queryParameters['redirectPath'] = requestParameters.redirectPath;
    }

    if (requestParameters.effectiveDate !== undefined) {
      queryParameters['effectiveDate'] = (requestParameters.effectiveDate as any).toISOString();
    }

    if (requestParameters.locale !== undefined) {
      queryParameters['locale'] = requestParameters.locale;
    }

    if (requestParameters.pid !== undefined) {
      queryParameters['pid'] = requestParameters.pid;
    }

    if (requestParameters.siteId !== undefined) {
      queryParameters['siteId'] = requestParameters.siteId;
    }

    if (requestParameters.status) {
      queryParameters['status'] = requestParameters.status;
    }

    if (requestParameters.userId !== undefined) {
      queryParameters['userId'] = requestParameters.userId;
    }

    if (requestParameters.audienceIds) {
      queryParameters['audienceIds'] = requestParameters.audienceIds;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyInternal !== undefined &&
      requestParameters.xChewyInternal !== null
    ) {
      headerParameters['X-Chewy-Internal'] = String(requestParameters.xChewyInternal);
    }

    const response = await this.request(
      {
        path: `/v1/preview`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Preview the requested page
   */
  async getRedirect(
    requestParameters: GetRedirectRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<void> {
    await this.getRedirectRaw(requestParameters, initOverrides);
  }
}

/**
 * @export
 */
export const GetRedirectLocaleEnum = {
  EnUs: 'EN_US',
} as const;
export type GetRedirectLocaleEnum = typeof GetRedirectLocaleEnum[keyof typeof GetRedirectLocaleEnum];
/**
 * @export
 */
export const GetRedirectSiteIdEnum = {
  NUMBER_10: 10,
} as const;
export type GetRedirectSiteIdEnum = typeof GetRedirectSiteIdEnum[keyof typeof GetRedirectSiteIdEnum];
